import React from 'react';
import CustomerDrawerContent from './CustomerDrawerContent';

interface IPROPS {
   storedGeoLoaction: any
   setStoreGeoLocationData: any
   setStoreVehicleInfo:any
   storeVehicleInfo:any
   setOpenVehicleModal:any
   setOpenModal:any
   setIsWorkshopSelectorClicked:any
   setIsCartOpen:any
   vehicleData:any
   setCurrentStep:any
   homeApiData:any


}


const CustomerDrawer: React.FC<IPROPS> = ({homeApiData,setCurrentStep, vehicleData, setIsCartOpen,setIsWorkshopSelectorClicked, setOpenModal, setOpenVehicleModal, setStoreGeoLocationData}) => {

  return (
     <div>
        <CustomerDrawerContent homeApiData={homeApiData} setCurrentStep={setCurrentStep} vehicleData={vehicleData} setIsCartOpen={setIsCartOpen} setIsWorkshopSelectorClicked={setIsWorkshopSelectorClicked} setOpenModal={setOpenModal} setOpenVehicleModal={setOpenVehicleModal}  setStoreGeoLocationData={setStoreGeoLocationData} />
     </div>
  );
};

export default CustomerDrawer;